/**
 * PdfExportProvider
 *
 * Wraps the off-screen export portal mounted by `usePdfPortal` and publishes the
 * scope that subtree renders at: the portal flag, the visibility view
 * (SYD-1948) and the split (SYD-2302). Both overrides are optional and omitted
 * everywhere else, so on-screen readers keep falling through to the live
 * `formStore` values. The provider only forwards — it owns no state, and the
 * caller decides when a new split has committed.
 */

import { FC, ReactNode } from 'react';
import type { SplitQuery, VisibilityTypeId } from '#types/System.types';
import { PdfExportContext } from './PdfExportContext';

interface PdfExportProviderProps {
  children: ReactNode;
  isPdfExportMode?: boolean;
  visibilityMode?: VisibilityTypeId;
  splitQuery?: SplitQuery;
}

const PdfExportProvider: FC<PdfExportProviderProps> = ({
  children,
  isPdfExportMode = false,
  visibilityMode,
  splitQuery,
}) => (
  <PdfExportContext.Provider value={{ isPdfExportMode, visibilityMode, splitQuery }}>
    {children}
  </PdfExportContext.Provider>
);

export default PdfExportProvider;
